
import { secureHTML } from '@packages/toolbox';
import { computed, defineComponent, ref } from 'vue';

import { useLoading } from 'SharedDir/common/composables/useLoading';
import { useNotificationStore } from 'SharedDir/stores/notification.store';

export default defineComponent({
  name: 'WafDialog',
  props: {
    wafSupport: {
      type: String,
      required: true,
      default: undefined,
    },
  },
  setup(props, { emit }) {
    const helpdeskEmail = 'helpdesk@admhmao.ru';

    const notificationStore = useNotificationStore();
    const { action: loading } = useLoading();

    const subscriber = ref<null | (() => void)>(null);

    const titleForm = ref('Сработала защита WAF');

    const wafError = computed(() => notificationStore.getWafError);

    const dialogVisibility = computed({
      get: () => !!wafError.value.id,
      set: (value: boolean) => {
        if (!value) {
          notificationStore.resetWafError();
        }
      },
    });

    const safeContent = computed(() => {
      return secureHTML(wafError.value.content);
    });

    const mailToParams = (emails: string) => {
      const params = {
        subject: 'Сработала защита WAF',
        body: encodeURIComponent(
          `Добрый день!\n При посещении страницы по адресу ${window.location.href} получил` +
            ` сообщение о срабатывании защиты WAF с идентификатором блокировки ${wafError.value.id}`
        ),
      };

      const paramsString = Object.entries(params)
        .map(([name, value]) => `${name}=${value}`)
        .join('&');

      return `mailto:${emails}?${paramsString}`;
    };

    const mailToLinkHelpdesk = computed(() => mailToParams(helpdeskEmail));

    const mailToLink = computed(() => {
      if (!props.wafSupport) {
        return '';
      }

      return mailToParams(props.wafSupport);
    });

    function close(): void {
      dialogVisibility.value = false;
      emit('update:show', dialogVisibility.value);
    }

    return {
      dialogVisibility,
      titleForm,
      loading,
      close,
      mailToLink,
      safeContent,
      mailToLinkHelpdesk,
      helpdeskEmail,
    };
  },
});
